import Cookie from "universal-cookie";

const cookie = new Cookie();

class CookieService {
  get(key:any) {
    return cookie.get(key);
  }

  set(key:any, value:any, options:any) {
    cookie.set(key, value, options);
  }

  remove(key:any) {
    cookie.remove(key);
  }
}

export default new CookieService();